/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var StackHDownIcon24Regular = forwardRef('StackHDownIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M8.25 2a.75.75 0 0 0 0 1.5h7.5a.75.75 0 0 0 0-1.5h-7.5Z" }),
        React.createElement("path", { d: "M5.25 5.75A.75.75 0 0 1 6 5h12a.75.75 0 0 1 0 1.5H6a.75.75 0 0 1-.75-.75Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 11.75A3.75 3.75 0 0 1 5.75 8h12.5A3.75 3.75 0 0 1 22 11.75v6.5A3.75 3.75 0 0 1 18.25 22H5.75A3.75 3.75 0 0 1 2 18.25v-6.5ZM5.75 9.5a2.25 2.25 0 0 0-2.25 2.25v6.5a2.25 2.25 0 0 0 2.25 2.25h12.5a2.25 2.25 0 0 0 2.25-2.25v-6.5a2.25 2.25 0 0 0-2.25-2.25H5.75Z" })));
});
